import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { easeCurves } from "../../motion/eases";
import React from 'react';
import styled, { keyframes } from 'styled-components';
import { theme } from "../../theme";
var fade = keyframes(["0%{opacity:.5}100%{opacity:1}"]);
var StyledSkeleton = styled.span.withConfig({
  displayName: "Skeleton__StyledSkeleton",
  componentId: "vapor__sc-1pezjrh-0"
})(["background-color:", ";background-repeat:no-repeat;border-radius:", ";display:inline-block;line-height:1;width:", ";height:", ";animation-duration:700ms;opacity:0.5;animation-timing-function:", ";animation-iteration-count:infinite;animation-direction:alternate;animation-delay:", "s;animation-name:", ";& > *{visibility:hidden;}"], theme.colors.palette.whiteA15, function (p) {
  return p.$rounded ? '50%' : theme.radii[4];
}, function (p) {
  var _theme$spaces$p$$widt;

  return (_theme$spaces$p$$widt = theme.spaces[p.$width]) !== null && _theme$spaces$p$$widt !== void 0 ? _theme$spaces$p$$widt : p.$width;
}, function (p) {
  var _theme$spaces$p$$heig;

  return (_theme$spaces$p$$heig = theme.spaces[p.$height]) !== null && _theme$spaces$p$$heig !== void 0 ? _theme$spaces$p$$heig : p.$height;
}, easeCurves.primary, function (p) {
  var _p$$delay;

  return (_p$$delay = p.$delay) !== null && _p$$delay !== void 0 ? _p$$delay : 0;
}, fade);
export var SkeletonContainer = styled.div.withConfig({
  displayName: "Skeleton__SkeletonContainer",
  componentId: "vapor__sc-1pezjrh-1"
})(["position:relative;"]);
export function Skeleton(_ref) {
  var _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '100%' : _ref$width,
      _ref$ariaValuetext = _ref['aria-valuetext'],
      ariaValueText = _ref$ariaValuetext === void 0 ? 'loading' : _ref$ariaValuetext,
      height = _ref.height,
      delay = _ref.delay,
      children = _ref.children,
      other = _objectWithoutProperties(_ref, ["rounded", "width", "aria-valuetext", "height", "delay", "children"]);

  return /*#__PURE__*/React.createElement(StyledSkeleton, _extends({
    "aria-busy": "true",
    "aria-valuemax": 100,
    "aria-valuemin": 0,
    "aria-valuetext": ariaValueText,
    role: "progressbar",
    $width: width,
    $height: height,
    $rounded: rounded,
    $delay: delay
  }, other), children || /*#__PURE__*/React.createElement(React.Fragment, null, "\u200C"));
}